import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["size", "data", "numOfAvatars"];
import PropTypes from 'prop-types';
import React from 'react';
import { Flex } from '../Layout';
import { Avatar } from './Avatar';
const AvatarStack = Flex;
export const AvatarList = _ref => {
  let {
      size,
      data,
      numOfAvatars
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return React.createElement(AvatarStack, _extends({
    position: "relative",
    alignItems: "center"
  }, props), data === null || data === void 0 ? void 0 : data.slice(0, numOfAvatars).map((user, i) => React.createElement(Avatar, {
    key: user.id,
    size: size,
    src: user.profileImageUrl,
    hasBorder: true,
    marginRight: i < numOfAvatars - 1 ? '-12px' : 0
  })));
};
AvatarList.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    profileImageUrl: PropTypes.string
  })),
  size: PropTypes.oneOf(['micro', 'tiny', 'small', 'medium', 'large', 'huge']),
  numOfAvatars: PropTypes.number
} : {};
AvatarList.defaultProps = {
  data: null,
  size: 'medium',
  numOfAvatars: 5
};